import axios from "axios";

/**
 * Deletes a prospect history event using the backend API.
 * @param {number} eventId - The ID of the prospect history event to delete.
 * @returns {Promise<any>} - Resolves with the API response when successful.
 */
const deleteProspectHistoryEvent = async (eventId: number): Promise<any> => {
  try {
    // Construct the payload
    const payload = { Id: eventId };

    console.log("DEBUG deleteProspectHistoryEvent.ts: Sending payload to API:", payload);

    // Make the POST request
    const { data } = await axios({
      method: "POST",
      url: `/api/cantrackv3/DeleteProspectHistoryEvent`,
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: { payload },
    });

    console.log("DEBUG deleteProspectHistoryEvent.ts: Event deleted successfully:", data);
    return data;
  } catch (error) {
    console.error("DEBUG deleteProspectHistoryEvent.ts: Error deleting event:", error);
    throw error;
  }
};

export default deleteProspectHistoryEvent;
